export enum RegistrationStatus {
  RESERVED_FOR_MANDATORY_PAYMENT = 0,
  CONFIRMED = 1,
  RESERVED_FOR_PAYMENT = 2
}
